<template>
  <div>
    <b-container>
        <b-row>
            <b-col>
                <h2 class="theShopCss">Shop</h2>
            </b-col>
            <b-col>
                <button class="snipcart-checkout" style="margin-top:2em">
                    🛒 Cart ({{ cartCount }})
                    - ${{ cartTotal }}
                </button>
            </b-col>
        </b-row>
        <div style="margin-top: 5em;">
            <b-row>
                <b-col v-for="(list, index) in acf.acf.shopping_items" :key="index + 'list1'">
                    <div>
                        <img class="imgShop" :src="list.item_image">
                        <h2 class="itemName">{{list.item_name}}</h2>
                        <p class="itemDesc" v-html="list.item_desciption"></p>
                        <h2 class="itemPrice">£{{list.item_price}}</h2>
                    </div>
                    <button
                        class="snipcart-add-item"
                        :data-item-id="'product' + index"
                        :data-item-name="list.item_name"
                        :data-item-price="list.item_price"
                        data-item-url="/shop"
                        :data-item-description="list.item_description"
                        :data-item-image="list.item_image"
                    >
                    Add to Cart
                    </button>
                </b-col>
            </b-row>
        </div>
    </b-container>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "shop",

  data() {
    return {
      cartCount: 0,
      cartTotal: "0.00",
      acf:[]
    };
  },
  methods: {
    shopContent: function() {
        axios //add API Call
            .get(
                'https://wp-cpt.ocs-software.com/' + "/wp-json/wp/v2/pages/1426"
            ) // Page number changed on each page based on JSON page id you are calling
            .then((response) => (
                this.acf = response.data
            )); //API data wanted pulled out
        }
  },

  mounted() {
    this.shopContent();
    const addContinueShoppingButton = () => {
      const timer = setInterval(() => {

        // Find the cart container
        const container = document.querySelector(".snipcart-modal__container");

        if (!container) return;

        // Already added?
        if (container.querySelector(".my-continue-shopping")) {
          clearInterval(timer);
          return;
        }

        // const button = document.createElement("button");

        // button.className = "my-continue-shopping";

        // button.innerHTML = "← Continue shopping";

        // button.onclick = () => {
        //   window.location.hash = "";
        //   this.$router.push("/shop");
        // };

        // container.prepend(button);

        clearInterval(timer);

      }, 100);
    };

    const initSnipcart = () => {

      if (!window.Snipcart) return;

      const updateCart = () => {

        const cart = window.Snipcart.store.getState().cart;

        const items = cart.items?.items || [];

        this.cartCount = items.length;

        this.cartTotal = cart.total
          ? Number(cart.total).toFixed(2)
          : "0.00";
      };

      updateCart();

      window.Snipcart.store.subscribe(updateCart);

      window.Snipcart.events.on("item.added", () => {
        addContinueShoppingButton();
      });

    };

    if (window.Snipcart?.store) {
      initSnipcart();
    } else {
      document.addEventListener("snipcart.ready", initSnipcart);
    }
  }
};
</script>
<style scoped>
button.snipcart-checkout:hover {
    background-color: transparent;
    border: 1px solid #081c3f;
    color: #081C3F;
}
button.snipcart-checkout {
    background: #081c3f;
    color: #fff;
    border-radius: 0;
    border: 0 solid #081c3f;
    font-size: 18px;
    transition: all .4s ease;
    transition: all .35s cubic-bezier(.37, 0, .63, 1);
    border-radius: 26px;
    width: 272px;
    height: 52px;
    font-family: brown-pro-condensed, sans-serif;
    font-weight: 800;
    font-style: normal;
}
button.snipcart-add-item:hover {
    background-color: transparent;
    border: 1px solid #081c3f;
    color: #081C3F;
}
button.snipcart-add-item {
    background: #081c3f;
    color: #fff;
    border-radius: 0;
    border: 0 solid #081c3f;
    font-size: 18px;
    transition: all .4s ease;
    transition: all .35s cubic-bezier(.37, 0, .63, 1);
    border-radius: 26px;
    width: 272px;
    height: 52px;
    font-family: brown-pro-condensed, sans-serif;
    font-weight: 800;
    font-style: normal;
}
.imgShop {
    width: 100%;
    max-height: 370px;
}
.itemName {
    padding-top: 30px;
}
.itemDesc {
    padding-top: 10px;
}
.itemPrice {
    padding-top: 10px;
    padding-bottom: 10px;
}
button.snipcart-checkout {
    float: right;
    position: relative;
    top: 5em;
}
.theShopCss {
    color: #081c3f;
    font-size: 80px;
    text-align: left;
    font-family: brown-pro-condensed, sans-serif;
    font-weight: 800;
    font-style: normal;
    margin-bottom: 0;
    padding-top: 90px;
    padding-bottom: 40px;   
}
.my-continue-shopping {
    display: block;
    width: 100%;
    text-align: left;
    padding: 15px 20px;
    border: 0;
    background: white;
    font-size: 15px;
    font-weight: 600;
    color: #081C3F;
    cursor: pointer;
    border-bottom: 1px solid #ddd;
}

.my-continue-shopping:hover {
    background: #f7f7f7;
}
::v-deep .snipcart-continue-shopping {
    display: block !important;
}
::v-deep ul.snipcart-item-list.snipcart-scrollbar.snipcart-item-list--no-shadow {
    margin-top: 15em;
}
::v-deep .snipcart-cart__content {
    margin: 0 auto;
    background-color: #f1f2f4;
    background-color: var(--bgColor-modal, #f1f2f4);
    margin-top: 17em !important;
}
::v-deep .snipcart-item-list {
    list-style: none;
    padding: 0;
    margin: 0;
    margin-bottom: 32px;
    margin-top: 19em!important;
}
::v-deep .snipcart-modal__container {
    width: calc(40% + 1px)!important;
    overflow-x: hidden;
    padding-right: 1px;
    right: 0!important;
}
.underCon.container {
  margin: auto;
  text-align: center;
  margin-top: 5em;
  background: #efefef;
  padding-bottom: 30px;
}
@font-face {
	font-family: 'Grift-Bold'!important;
	font-weight: normal;
	font-style: normal;
	/* src: url('https://wp-cpt.ocs-software.com/wp-content/themes/wp-bootstrap-starter/fonts/Grift-Regular.ttf'); */
	src: url('https://wp-cpt.ocs-software.com/wp-content/themes/wp-bootstrap-starter/fonts/Grift-Bold.ttf')!important;
}
span.boldText {
  font-weight: bold;
  /* padding-bottom: 20px; */
  margin-bottom: 20px;
  display: block;
  font-family: 'Grift-Bold', sans-serif;
}
.postSection {
  margin-top: 8%;
}
img {
  width: 100%;
}
.black {
  color: #081C3F!important;
}
.bkBlack {
 background-color: #081C3F; 
 padding: 3%;
 margin-top: 50px;
}
.whiteCon {
 padding: 3%;
 margin-top: 50px;
}
.heading {
  /* font-weight: 600; */
  font-size: 36px;
  color: #081C3F;
  padding-top: 40px;
  padding-bottom: 40px;
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
}
.paddingBottom {
  padding-bottom: 50px;
}
h2.headingPost {
  /* font-weight: 600; */
  font-size: 30px;
  color: #081C3F;
  padding-top: 40px;
  padding-bottom: 40px;
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
}
p.textPost {
  font-size: 20px;
  color: #ffff;
}
@media only screen and (max-width: 1199px) {
  .underCon.container {
    margin: auto;
    text-align: center;
    margin-top: 0em;
    background: #efefef;
    padding-bottom: 30px;
  }
}
@media only screen and (max-width: 510px) {
  h2.headingPost {
    /* font-weight: 600; */
    font-size: 30px;
    color: #081C3F;
    padding-top: 0px;
    padding-bottom: 20px;
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
  }
  .whiteCon {
    padding: 3%;
    margin-top: 0px;
  }
}
</style>
